@if (intialized) {
  <div class="session-slots">
    @for (slot of SessionSlots; track slot; let i = $index) {
      <div class="session-slot">
        <input [disabled]="slot.disabled || slot.disabledOverlaped" class="session-slot__checkbox" [id]="'session_'+i+'_'+slot.Start"
          type="checkbox" [(ngModel)]="SessionSlots[i].checked" (change)="onSlotClick(SessionSlots[i])" />
          <label [attr.for]="'session_'+i+'_'+slot.Start" class="session-slot__btn"
            [ngStyle]="{'border-color':slot.color, 'color': slot.color}">
            @if (!slot.SessionGroupId) {
              <div class="session-slot__session-name"
              title="{{'Session' | translate}} {{i+1}}">{{'session' | translate}} {{i+1}}</div>
            }
            @if (slot.SessionGroupId) {
              <div class="session-slot__session-name" [title]="slot.SessionGroupName">
              {{slot.SessionGroupName}}</div>
            }
            @if (!slot.SessionGroupId) {
              <span>{{slot.Start | localizeDate: 'LT'}} - {{slot.End | localizeDate: 'LT'}}</span>
            }
          </label>
        </div>
      }
    </div>
  }